import React from 'react';
import styled, { StyledComponentProps } from 'styled-components';
import { convertPropsToCssRules } from '../../helpers/styled';
import { getColumnSpacingRules } from '../../helpers/css';

/* Interfaces */
interface PropsToPaste {
  height?: string;
  justifyContent?: string;
  maxHeight?: string;
  maxWidth?: string;
  width?: string;
}

interface AdditionalProps extends PropsToPaste {
  children: React.ReactNode;
  spacingBetweenItemsHalved?: string;
}

export type ColumnProps = StyledComponentProps<'div', any, AdditionalProps, never>;

/* Components */
export const Column = styled.div.attrs({ className: 'icb' as string })<ColumnProps>`
  ${convertPropsToCssRules<PropsToPaste>(['height', 'justifyContent', 'maxHeight', 'maxWidth', 'width'])};

  display: flex;
  flex-direction: column;

  ${({ spacingBetweenItemsHalved }) =>
    spacingBetweenItemsHalved ? getColumnSpacingRules(spacingBetweenItemsHalved) : ''}
`;
